//@helpers
const actionTypes = require('constants/actionTypes');
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
//@actions
const signaturePatternActions = require('actions/signaturePattern');

function clearIntervenerRemoval() {
    return {
        type: actionTypes.ACCOUNT_INTERVENERS_REMOVE_RESET
    };
}

function successRemoveIntervener(accountId, intervenerIndex) {
    return {
        type: actionTypes.ACCOUNT_INTERVENERS_REMOVE_SUCCESS,
        payload: {
            accountId,
            intervenerIndex
        }
    };
}

function errorRemoveIntervener(error) {
    return {
        type: actionTypes.ACCOUNT_INTERVENERS_REMOVE_FAILURE,
        payload: {
            error
        }
    };
}

function requestRemoveIntervener() {
    return {
        type: actionTypes.ACCOUNT_INTERVENERS_REMOVE_REQUEST
    }
}

const removeIntervener = (accountId, intervenerIndex) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immAccount = getState().accounts.get('byId').get(accountId);
        const immIntervener = immAccount.get('interveners').get('list').get(intervenerIndex);
        const requestData = {
            query: {
                dataToken,
                datosConexion: {
                    contrato: {
                        numerodecontrato: immAccount.get('contractNumber'),
                        producto: immAccount.get('product')
                    }
                },
                identificadorPersona: {
                    codigodepersona: parseInt(immIntervener.get('identification').get('code'), 10),
                    tipodepersona: immIntervener.get('identification').get('type')
                },
                ordenIntervencion: parseInt(immIntervener.get('interventionOrder'), 10)
            }
        };

        dispatch(requestRemoveIntervener());
        APIPost(dispatch, apiURLBuilder.getURL('accountIntervenersRemove'), requestData).then(
            response => {
                if (response.respuesta !== null) {
                    dispatch(errorRemoveIntervener(response.respuesta));
                } else {
                    dispatch(successRemoveIntervener(accountId, intervenerIndex));
                }
            }, response => {
                dispatch(errorRemoveIntervener(response.error.description));
            }
        );
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    removeIntervener,
    clearIntervenerRemoval
}
